import { render } from "./PlanillasObservaciones.vue?vue&type=template&id=10632812&scoped=true"
import script from "./PlanillasObservaciones.vue?vue&type=script&lang=js"
export * from "./PlanillasObservaciones.vue?vue&type=script&lang=js"

import "./PlanillasObservaciones.vue?vue&type=style&index=0&id=10632812&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10632812"]])

export default __exports__